// src/pages/Accomplishments.js
import React from "react";
import "../App.css";

export default function Accomplishments() {
  const years = [
    {
      year: "2024–2025",
      highlights: [
        "District Champions",
        "Regional Semi-finalists",
        "Overall Record: 26–8",
      ],
    },
    {
      year: "2023–2024",
      highlights: [
        "Area Finalists",
        "District Champions",
      ],
    },
    {
      year: "2022–2023",
      highlights: [
        "District Champions",
        "Overall Record: ",
      ],
    },
  ];

  return (
    <div className="page accomplishments-page">
      <h1 className="page-title">Program Accomplishments</h1>
      <div className="accomplishments-list">
        {years.map((item, idx) => (
          <div key={idx} className="accomplishment-card">
            <h2>{item.year}</h2>
            <ul>
              {item.highlights.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
